/**
 * AI質問カードコンポーネント
 */

import { Lightbulb, MessageCircle, Sparkles } from 'lucide-react'

import type { InterviewQuestion } from '@/api/types/journal'
import { Card, CardContent } from '@/components/ui/card'

const CATEGORY_CONFIG: Record<string, { icon: typeof Sparkles; color: string; borderColor: string }> = {
  reflection: { icon: Sparkles, color: 'text-purple-500', borderColor: 'var(--color-purple-500)' },
  discovery: { icon: Lightbulb, color: 'text-yellow-500', borderColor: 'var(--color-yellow-500)' },
  connection: { icon: MessageCircle, color: 'text-blue-500', borderColor: 'var(--color-blue-500)' },
  emotion: { icon: Sparkles, color: 'text-pink-500', borderColor: 'var(--color-pink-500)' },
  growth: { icon: Sparkles, color: 'text-green-500', borderColor: 'var(--color-green-500)' },
}

type Props = {
  question: InterviewQuestion
  onSelect: (question: InterviewQuestion) => void
}

export const QuestionCard = ({ question, onSelect }: Props) => {
  const config = CATEGORY_CONFIG[question.category] ?? CATEGORY_CONFIG.reflection
  const Icon = config.icon

  return (
    <Card
      className="cursor-pointer transition-all hover:shadow-md active:scale-[0.98] border-l-3"
      style={{ borderLeftColor: config.borderColor }}
      onClick={() => onSelect(question)}
    >
      <CardContent className="p-3">
        <div className="flex items-start gap-2">
          <Icon className={`size-4 mt-0.5 shrink-0 ${config.color}`} />
          <div className="space-y-1 min-w-0">
            <p className="text-sm font-medium leading-snug">{question.question}</p>
            <p className="text-xs text-muted-foreground truncate">{question.trigger_data}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
